import React, { FC } from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemText from '@mui/material/ListItemText'
import ListItemAvatar from '@mui/material/ListItemAvatar'

import UploadedImage from '../widgets/UploadedImage'

import {
  IRecord_KnowledgeBase,

} from '@kaidam/fc-shared/src/types/schema/knowledgebase'

interface ArticleMenuProps {
  articles: IRecord_KnowledgeBase[],
  selected?: string,
  onSelect: {
    (article: IRecord_KnowledgeBase): void,
  }
}

const ArticleMenu: FC<React.PropsWithChildren<ArticleMenuProps>> = ({
  articles,
  selected = '',
  onSelect,
}) => {

  return (
    <List>
      {
        articles.map((article, i) => {
          return (
            <ListItem
              key={ article.id }
              selected={ article.id == selected }
              button
              onClick={ () => onSelect(article) }
            >
              {
                article.screenshot && (
                  <ListItemAvatar>
                    <UploadedImage
                      file={ article.screenshot }
                      avatar
                    />
                  </ListItemAvatar>
                )
              }
              <ListItemText
                primary={ article.name }
              />
            </ListItem>
          )
        })
      }
    </List>
  )
}

export default ArticleMenu